export const extraCareServiceName = 'JB Hi-Fi Extra Care';

export enum ServiceIds {
  MobileExtras = 'mobile-extras',
  ExtraCare = 'extended-care',
  ExtraCareNz = 'extended-care-nz',
  AppleCareNz = 'apple-care-nz',
}
